import { Button, darken, TextField } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const Title = styled.h1`
  text-align: center;
  font-family: sans-serif;
  font-size: 2rem;
  line-height: 1.1;
  font-weight: 700;

  padding-top: 8px;
  padding-bottom: 24px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
`;

export const Label = styled.p`
  flex: 0.333%;
  margin-right: 12px;
  font-weight: 600;
  color: #3b3b3b;
  font-size: 16px;
`;

export const Input = styled(TextField)`
  /* & label.Mui-focused {
    color: ${COLORS.GRAY_4};
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${COLORS.GRAY_4};
    }
  } */
`;

export const LoginButton = styled(Button)`
  width: 100%;
  margin-top: 24px;

  background-color: ${COLORS.GREEN};
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 8px 28px;
  border-radius: 3px;

  align-self: center;

  &:disabled {
    opacity: 0.7;
    filter: grayscale(0.5);
  }

  &:hover {
    background-color: ${darken(COLORS.GREEN, 0.1)};
  }
`;

export const Error = styled.p`
  color: ${COLORS.DARK_RED};
  font-size: 0.875rem;
  margin-top: 6px;
  margin-left: 4px;
`;

export const LogoContainer = styled.div`
  max-width: 800px;
  margin-bottom: 1rem;
  margin-top: 5rem;

  img {
    width: 100%;
  }
`;

export const Socials = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  max-width: 250px;

  a {
    display: inline-block;
    width: 42%;
    img {
      width: 100%;
    }
  }
`;

export const Banner = styled.div`
  max-width: 800px;
  margin-top: auto;

  img {
    width: 100%;
  }

  p {
    max-width: 400px;
    font-size: 0.6125rem;
    margin: auto;
  }
`;

export const Acceptances = styled.div`
  max-width: 600px;
  line-height: 1.1rem;
`;

export const AcceptanceLine = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 0.875rem;
  max-width: 440px;

  a {
    color: #0070a8;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    margin-top: 0.675rem;
  }
`;

export const DataInfoHeader = styled.div`
  max-width: 440px;
  margin-top: 0.875rem;
  font-size: 0.75rem;
  line-height: 0.875rem;

  &:hover {
    cursor: pointer;
  }
`;

export const DataInfo = styled.div`
  max-width: 440px;
  margin-top: 0.875rem;
  font-size: 0.75rem;
  line-height: 0.875rem;

  ul {
    max-width: 410px;
    margin-top: 0.75rem;
    font-size: 0.75rem;
    padding-left: 1em;
    list-style: disc;

    li {
      margin-top: 0.375rem;
    }
  }
`;
